




































































import { Component, Prop, Vue } from 'vue-property-decorator'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

@Component({
  components: {
    vueCustomScrollbar,
  },
})
export default class BuilderMobileDevice extends Vue {
  scrollbarSettings = {
    suppressScrollY: false,
    suppressScrollX: false,
    wheelPropagation: false,
  }

  getApp!: any
  @Prop({ default: process.env.VUE_APP_INSTA_APP_DOMAIN, type: String }) domainName!: string

  @Prop({ type: String }) siteName!: string
  @Prop({ type: String }) color!: string

  get style() {
    if (this.$breakpoints.xs) {
      return { 'max-height': '100%' }
    }
    if (this.$breakpoints.tablet) {
      return { 'max-height': '85%' }
    }
    if (this.$breakpoints.desktop && this.$breakpoints.height < 900) {
      return { 'max-height': '90%' }
    }
    return { 'max-height': '800px' }
  }
}
